import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  isLoggedIn: boolean = false;
  userName: string | null = null;
  firstName: string = '';
  lastName: string = '';
  userEmail: string | null = null;
  userProfilePic: string = '../../assets/img/user-icon.png';

  constructor(public authService: MsalService, private router: Router) { }

  ngOnInit() {
    this.updateLoginState();
  }

  private updateLoginState() {
    const account: AccountInfo | null =
      this.authService.instance.getActiveAccount();
    this.isLoggedIn = account !== null;
    if (account) {
      this.userName = account.name || 'User';
      this.userEmail = account.username;
      const [first, last] = this.userName?.split(' ') || ['User', ''];
      this.firstName = first;
      this.lastName = last;

      const claims = account.idTokenClaims as { [key: string]: any };
      if (claims && claims['picture']) {
        this.userProfilePic = claims['picture'];
      }
    }
  }
}
